import React, { useEffect } from "react";
import { SlideshowLightbox, initLightboxJS } from "lightbox.js-react";

import gallery01 from "../assets/photos/gallery01.jpg";
import gallery02 from "../assets/photos/gallery02.jpg";
import gallery04 from "../assets/photos/gallery04.jpg";
import gallery05 from "../assets/photos/gallery05.jpg";
import gallery09 from "../assets/photos/gallery09.jpg";
import gallery11 from "../assets/photos/gallery11.jpg";
import gallery13 from "../assets/photos/gallery13.jpg";
import gallery14 from "../assets/photos/gallery14.jpg";
import gallery15 from "../assets/photos/gallery15.jpg";
import gallery16 from "../assets/photos/gallery16.jpg";
import gallery19 from "../assets/photos/gallery19.jpg";
import gallery20 from "../assets/photos/gallery20.jpg";
import gallery21 from "../assets/photos/gallery21.jpg";

export function Photos() {
    useEffect(() => {
        initLightboxJS("B78F-47EE-A22D-C766", "individual");
    });

    return (
        <div className="container">
            <h2 className="heading-secondary">Photos</h2>

            <SlideshowLightbox className="photo-gallery" showThumbnails={true} theme="dark" backgroundColor="black" iconColor="white" imgAnimation="fade" modalClose="clickOutside">
                <img src={gallery01} alt="Zayne sitting and holding an acoustic guitar." />
                <img src={gallery02} alt="Zayne standing and holding an acoustic guitar." />
                <img src={gallery04} alt="Zayne holding a Fender electric guitar." />               
                <img src={gallery05} alt="Zayne standing portrait." />
                <img src={gallery21} alt="Zayne playing an electric guitar." />
                <img src={gallery13} alt="Zayne playing an acoustic guitar in a doorway." />

                <img src={gallery14} alt="Zayne playing a grand piano." />                
                <img src={gallery16} alt="Zayne sitting in front of a grand piano." />

                {/** <img src={gallery07} alt="Zayne standing in an old alleyway." />
                <img src={gallery12} alt="Zayne sitting on top of an old building." /> */}          

                <img src={gallery09} alt="Zayne sitting in a stairwell with led lights." />
                {/** <img src={gallery10} alt="Zayne sitting in a stairwell with led lights." /> */}
                <img src={gallery11} alt="Zayne standing in a stairwell with led lights." />

                {/** <img src={gallery08} alt="Zayne sitting in front of an old, architectural building." /> */}

                {/** <img src={gallery17} alt="Zayne sitting in an open field playing an acoustic guitar." />
                <img src={gallery18} alt="Zayne walking in an open field with an acoustic guitar." /> */}

                <img src={gallery19} alt="Zayne playing an acoustic guitar." />
                <img src={gallery20} alt="Zayne holding an acoustic guitar." />

                
                <img src={gallery15} alt="Zayne playing a grand piano with subtle back lighting." />
                
            </SlideshowLightbox>
        </div>
    );
}